import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import TreeView from '@mui/lab/TreeView';
import { Typography } from '@mui/material';
import { useKeycloak } from '@react-keycloak/web';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import SidebarItem from './SidebarItem';

export default function Sidebar() {
  const { keycloak } = useKeycloak();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation(['sidebar', 'common']);
  const isAdmin =
    keycloak.hasResourceRole('ADMIN', process.env.REACT_APP_KEYCLOAK_CLIENT_ID) || process.env.REACT_APP_ENV === 'dev';
  const isControladoria =
    keycloak.hasResourceRole('CONTROLADORIA', process.env.REACT_APP_KEYCLOAK_CLIENT_ID) ||
    process.env.REACT_APP_ENV === 'dev';

  const selectedTree = (endpoint: string) => {
    if (endpoint.startsWith('/sharingDetail')) {
      return '11';
    }

    switch (endpoint) {
      case '/events':
        return '1';
      case '/processing':
        return '2';
      case '/general':
        return '3';
      case '/permission-by-product':
        return '4';
      case '/exception':
        return '5';
      case '/reversions':
        return '6';
      case '/projectExceptions':
        return '7';
      case '/notShared':
        return '8';
      case '/employeeEvents':
        return '9';
      case '/classifyIncentivized':
        return '10';
      case '/sharingDetail':
        return '11';
      default:
        return '1';
    }
  };
  return (
    <TreeView
      selected={selectedTree(location.pathname)}
      aria-label="gmail"
      defaultExpanded={['3']}
      defaultCollapseIcon={<ArrowDropDownIcon />}
      defaultExpandIcon={<ArrowRightIcon />}
      defaultEndIcon={<div style={{ width: 24 }} />}
      sx={{ height: 264, flexGrow: 1, width: 280, paddingLeft: '2rem' }}
    >
      {isControladoria && (
        <>
          <Typography variant="h2" sx={{ marginY: '1rem', fontWeight: 'bold' }}>
            {t('salary')}
          </Typography>
          <SidebarItem
            active={selectedTree(location.pathname) === '1'}
            nodeId="1"
            labelText={t('common:events')}
            labelInfo="2,294"
            color="#e3742f"
            bgColor="#fcefe3"
            badgeColor="warning"
            onClick={() => {
              navigate('events');
            }}
          />
          <SidebarItem
            active={selectedTree(location.pathname) === '2'}
            nodeId="2"
            labelText={t('processing')}
            labelInfo="3,566"
            color="#e3742f"
            bgColor="#fcefe3"
            badgeColor="warning"
            onClick={() => {
              navigate('processing');
            }}
          />
          <SidebarItem
            active={selectedTree(location.pathname) === '5'}
            nodeId="5"
            labelText={t('common:benefit.exceptions')}
            labelInfo="3,566"
            color="#e3742f"
            bgColor="#fcefe3"
            badgeColor="warning"
            onClick={() => {
              navigate('exception');
            }}
          />
          <SidebarItem
            active={selectedTree(location.pathname) === '7'}
            nodeId="7"
            labelText={t('common:exceptions.charges')}
            labelInfo="3,566"
            color="#e3742f"
            bgColor="#fcefe3"
            badgeColor="warning"
            onClick={() => {
              navigate('projectExceptions');
            }}
          />
          <SidebarItem
            active={selectedTree(location.pathname) === '6'}
            nodeId="6"
            labelText={t('reversal.rules')}
            labelInfo="3,566"
            color="#e3742f"
            bgColor="#fcefe3"
            badgeColor="warning"
            onClick={() => {
              navigate('reversions');
            }}
          />
          <SidebarItem
            active={selectedTree(location.pathname) === '10'}
            nodeId="10"
            labelText={t('classify.incentivized')}
            labelInfo="2,294"
            color="#e3742f"
            bgColor="#fcefe3"
            badgeColor="warning"
            white-space="nowrap"
            onClick={() => {
              navigate('classifyIncentivized');
            }}
          />

          <Typography variant="h2" sx={{ marginY: '1rem', fontWeight: 'bold' }}>
            {t('Consultas')}
          </Typography>
          <SidebarItem
            active={selectedTree(location.pathname) === '8'}
            nodeId="8"
            labelText={t('on.the.sheet.without.allocation')}
            labelInfo="2,294"
            color="#e3742f"
            bgColor="#fcefe3"
            badgeColor="warning"
            onClick={() => {
              navigate('notShared');
            }}
          />
          <SidebarItem
            active={selectedTree(location.pathname) === '9'}
            nodeId="9"
            labelText={t('events.by.employee')}
            labelInfo="2,294"
            color="#e3742f"
            bgColor="#fcefe3"
            badgeColor="warning"
            white-space="nowrap"
            onClick={() => {
              navigate('employeeEvents');
            }}
          />
          <SidebarItem
            active={selectedTree(location.pathname) === '11'}
            nodeId="11"
            labelText={t('common:sharing.detail')}
            labelInfo="2,294"
            color="#e3742f"
            bgColor="#fcefe3"
            badgeColor="warning"
            white-space="nowrap"
            onClick={() => {
              navigate('sharingDetail');
            }}
          />

          <Typography variant="h2" sx={{ marginY: '1rem', fontWeight: 'bold' }}>
            {t('common:settings')}
          </Typography>
          <SidebarItem
            active={selectedTree(location.pathname) === '3'}
            nodeId="3"
            labelText={t('general')}
            labelInfo="2,294"
            color="#e3742f"
            bgColor="#fcefe3"
            badgeColor="warning"
            onClick={() => {
              navigate('general');
            }}
          />
        </>
      )}
      {isAdmin && (
        <>
          <Typography variant="h2" sx={{ marginY: '1rem', fontWeight: 'bold' }}>
            {t('admin')}
          </Typography>
          <SidebarItem
            active={selectedTree(location.pathname) === '4'}
            nodeId="4"
            labelText={t('product.permission')}
            color="#e3742f"
            bgColor="#fcefe3"
            onClick={() => {
              navigate('permission-by-product');
            }}
          />
        </>
      )}
    </TreeView>
  );
}
